import {
    StatusCreateReq,
    TransitionCreateReq,
    TransitionDetailRes,
    WorkflowCreateReq,
    WorkflowDetailRes,
    WorkflowUpdatePosReq as WorkflowUpdatePositions
} from '../../../../contracts/v0/crm';
import {ApiV0Crm} from '../api.v0.crm';
import {Observable} from 'rxjs';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';

export class ApiV0CrmWorkflow {
    segment: string = '/Workflow'


    // @ts-ignore
    constructor(v0: ApiV0Crm, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }


    search(searchModel?: SearchModel): Observable<BaseCollectionModel<WorkflowDetailRes>> {
        return this.rest.post<SearchModel, BaseCollectionModel<WorkflowDetailRes>>(`${this.segment}/search`, WorkflowDetailRes, searchModel)
    }

    createWorkflow(createReq: WorkflowCreateReq): Observable<BaseCollectionModel<WorkflowDetailRes>> {
        return this.rest.post<WorkflowCreateReq, BaseCollectionModel<WorkflowDetailRes>>(`${this.segment}`, WorkflowDetailRes, createReq)
    }

    updatePosition(updateReq:WorkflowUpdatePositions):Observable<WorkflowDetailRes>{
        return this.rest.patch<WorkflowUpdatePositions,WorkflowDetailRes>(`${this.segment}/position`, WorkflowDetailRes, updateReq)
    }

    createStatus(createReq: StatusCreateReq): Observable<WorkflowDetailRes> {
        return this.rest.post<StatusCreateReq, WorkflowDetailRes>(`${this.segment}/status`, WorkflowDetailRes, createReq);
    }

    deactivateStatus(id: number): Observable<WorkflowDetailRes> {
        return this.rest.delete<WorkflowDetailRes>(`${this.segment}/status?id=${id}`, WorkflowDetailRes)
    }

    connectedTransition(id:number):Observable<BaseCollectionModel<TransitionDetailRes>>{
        return this.rest.get<BaseCollectionModel<TransitionDetailRes>>(`${this.segment}/status/connected?id=${id}`,TransitionDetailRes)
    }

    createTransition(createReq: TransitionCreateReq): Observable<WorkflowDetailRes> {
        return this.rest.post<TransitionCreateReq, WorkflowDetailRes>(`${this.segment}/transition`, WorkflowDetailRes, createReq);
    }

    deactivateTransition(id: number): Observable<WorkflowDetailRes> {
        return this.rest.delete<WorkflowDetailRes>(`${this.segment}/transition?id=${id}`, WorkflowDetailRes)
    }
}
